// extracted by mini-css-extract-plugin
module.exports = {"container":"PopoverV2_container__CbBK3","content":"PopoverV2_content__1bsIl","appear":"PopoverV2_appear__GGcBK"};